import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
    class: "g-search-box",
    ref: "_searchBox"
};
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "search-container" };
const _hoisted_4 = { class: "input-group" };
const _hoisted_5 = {
    key: 0,
    class: "input-group-preappend group-back"
};
const _hoisted_6 = ["placeholder"];
const _hoisted_7 = ["title"];
const _hoisted_8 = {
    key: 0,
    class: "search-dropdown"
};
const _hoisted_9 = { class: "search-dropdown__container" };
const _hoisted_10 = { class: "d-flex flex-row quick-search__record" };
const _hoisted_11 = { class: "image__wrapper" };
const _hoisted_12 = { class: "image__container" };
const _hoisted_13 = ["src"];
const _hoisted_14 = { class: "text__wrapper" };
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_17 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_link = _resolveComponent("g-link");
    const _directive_click_outside = _resolveDirective("click-outside");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    (_ctx.mode === 'mobile')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("button", {
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                class: "btn btn-search",
                                type: "button"
                            }, [
                                _createVNode(_component_g_icon, {
                                    width: "16",
                                    height: "16",
                                    src: "/assets/icons/arrow-left.svg",
                                    style: { "margin-bottom": "2px" }
                                })
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        placeholder: _ctx.$tc('client.Common.Search.Promt'),
                        ref: "_searchInput",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchText) = $event)),
                        onFocus: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.onfocus && _ctx.onfocus(...args))),
                        onKeyup: _cache[3] || (_cache[3] = _withKeys(
                        //@ts-ignore
                        (...args) => (_ctx.gotoSearch && _ctx.gotoSearch(...args)), ["enter", "native"]))
                    }, null, 40, _hoisted_6), [
                        [_vModelText, _ctx.searchText]
                    ]),
                    _createElementVNode("div", {
                        class: "input-group-append",
                        title: _ctx.$tc('client.Common.Search')
                    }, [
                        _createElementVNode("button", {
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => (_ctx.gotoSearch && _ctx.gotoSearch(...args))),
                            class: "btn btn-search",
                            type: "button"
                        }, [
                            _createVNode(_component_g_icon, {
                                width: "16",
                                height: "16",
                                src: "/assets/icons/search.svg",
                                style: { "margin-bottom": "2px" }
                            })
                        ])
                    ], 8, _hoisted_7)
                ])
            ]),
            (_ctx.showSearchDropdown)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchData, (item) => {
                            return (_openBlock(), _createBlock(_component_g_link, {
                                onClick: ($event) => (_ctx.goto(item.link)),
                                class: "record",
                                href: "#"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("div", _hoisted_12, [
                                                _createElementVNode("img", {
                                                    src: item.imageUrl,
                                                    class: "image-item"
                                                }, null, 8, _hoisted_13)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("span", {
                                                class: "small",
                                                innerHTML: item.captionNumber
                                            }, null, 8, _hoisted_15),
                                            _hoisted_16,
                                            _createElementVNode("span", {
                                                innerHTML: item.caption
                                            }, null, 8, _hoisted_17)
                                        ])
                                    ])
                                ]),
                                _: 2
                            }, 1032, ["onClick"]));
                        }), 256)),
                        _createVNode(_component_g_link, {
                            onClick: _ctx.gotoSearch,
                            class: "record show-all"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$tc('client.Common.ShowAllRecords', _ctx.recordCount, { recordCount: _ctx.recordCount })), 1)
                            ]),
                            _: 1
                        }, 8, ["onClick"])
                    ])), [
                        [_directive_click_outside, _ctx.applyButton]
                    ])
                ]))
                : _createCommentVNode("", true)
        ])
    ], 512));
}
